import { render, staticRenderFns } from "./item-list.vue?vue&type=template&id=6aae6b3f&scoped=true"
import script from "./item-list.vue?vue&type=script&lang=js"
export * from "./item-list.vue?vue&type=script&lang=js"
import style0 from "./item-list.vue?vue&type=style&index=0&id=6aae6b3f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae6b3f",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/item-list.vue
// module id = OLqu
// module chunks = 0